import React from 'react'
import { Form } from 'semantic-ui-react'

export default class NameField extends React.PureComponent {
  render() {
    const { value, onChange } = this.props

    return (
      <Form.Input
        fluid
        label="Name"
        placeholder="e.g Muuve Pizza"
        required
        onChange={e => onChange('name', e.target.value)}
        value={value}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/restaurants/fields/nameField.js